export class CompanyInformation {
    constructor(companyRepository) {
      this.companyRepository = companyRepository;
    }
  
    async execute(CompanyId) {
      console.log('I am in CompanyInformation usecase');
      return await this.companyRepository.getCompanyInformation(CompanyId);
    }
  }